import * as React from 'react';
import { IBoxProps } from '@lce/slice';
import { split as _split } from 'lodash';

import { Container, MessageBox } from '../../ui';
import { SafeImage } from '../../ui/SafeImage';
import * as Styled from './MessageBanner.style';
import { Image, Script } from '../../lib/banners/types';

export interface IMessageBannerProps extends IBoxProps {
  images: Image[];
  heading?: string;
  link?: { 
    url: string;
    text: string;
  }
  text?: string;
  script: Script;
}

export const MessageBanner: React.FC<IMessageBannerProps> = ({ images, heading, link, script, text, ...props }) => {

  let messageImage = images[0];

  const selectImages = function(images: Image[]) {
    Object.keys(images).forEach(function(key: any) {
      if (images[key].type.toLowerCase().includes('message')) {
        messageImage = images[key];
      }
      return;
    });
    return;
  };

  selectImages(images);

  return(
         <Styled.MessageBanner as="section" data-testid="MessageBanner" {...props}>
           <Styled.BannerBackground>
             <Styled.BackgroundImage alt={messageImage.alt} data-testid="BannerBackgroundImage" src={messageImage.url} />
           </Styled.BannerBackground>
           <Container px="0">
             <Styled.FlexContainer>
               <Styled.BannerImage>
                 <SafeImage alt={messageImage.alt} data-testid="BannerImage" src={messageImage.url} />
               </Styled.BannerImage>
               {heading && (
                 <MessageBox heading={heading} link={link} script={script} template={'MessageBanner'} text={text} />
               )}
             </Styled.FlexContainer>
           </Container>
         </Styled.MessageBanner>
       )};
